// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3126) return "static/chunks/3126.a4990c934ce72793.js";
	if (chunkId === 9321) return "static/chunks/c913c06e.42ae11bcfc3f391c.js";
	if (chunkId === 7372) return "static/chunks/7372.9a5aaa769c61c822.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3964 ? "b9823a55" : chunkId) + "-" + {"1316":"5bb2b760358c937c","1639":"62185d80ab5deeb8","3945":"05f4a7c48a281d80","3964":"1ec8ccf3efc9fbe8","4769":"fa3ec6d1f2fcc590","6549":"2f9d7448a419e8ee","9001":"203d5a8290006535"}[chunkId] + ".js";
};